import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentLibraryPanelComponent } from './document-library-panel.component';
import { DocumentLibraryModule } from './document-library/document-library.module';


@NgModule({
  declarations: [DocumentLibraryPanelComponent],
  imports: [
    CommonModule,
    DocumentLibraryModule
  ],
  exports: [DocumentLibraryPanelComponent],
})
export class DocumentLibraryPanelModule { }
